import PostStreamState from 'flarum/forum/states/PostStreamState';
import Post from 'flarum/common/models/Post';
import app from 'flarum/forum/app';

import includePostNumber from '../utils/includePostNumber';

export default class TreePostStreamState extends PostStreamState {
  update(): Promise<void> | Promise<Post[]> {
    if (!this.viewingEnd()) return Promise.resolve();

    this.visibleEnd = this.count();

    return this.loadRange(this.visibleStart, this.visibleEnd);
  }

  loadRange(start: number, end: number): Promise<Post[]> {
    const loadIds: string[] = [];
    const loaded: Post[] = [];

    this.discussion
      .treeTopPostIds()
      .slice(start, end)
      .forEach((id) => {
        const post = app.store.getById<Post>('posts', id);

        if (post && post.discussion() && typeof post.canEdit() !== 'undefined') {
          loaded.push(post);
        } else {
          loadIds.push(id);
        }
      });

    if (loadIds.length) {
      return app.store.find<Post[]>('posts', loadIds).then((newPosts) => {
        return loaded.concat(newPosts).sort((a, b) => a.number() - b.number());
      });
    }

    return Promise.resolve(loaded);
  }

  show(posts: Post[]) {
    this.visibleStart = posts.length ? this.discussion.treeTopPostIds().indexOf(posts[0].id() ?? '0') : 0;
    this.visibleEnd = this.sanitizeIndex(this.visibleStart + posts.length);
  }

  posts(all?: boolean): (Post | null)[] {
    const postIds = all ? this.discussion.treeTopPostIds() : this.discussion.treeTopPostIds().slice(this.visibleStart, this.visibleEnd);

    return postIds.map((id) => {
      const post = app.store.getById<Post>('posts', id);

      return post && post.discussion() && typeof post.canEdit() !== 'undefined' ? post : null;
    });
  }

  count(): number {
    return this.discussion.treeTopPostIds().length;
  }

  loadNearNumber(number: number): Promise<void> {
    const index = this.posts(true).findIndex((post) => includePostNumber(post, number));

    if (index > -1) {
      if (index >= this.visibleStart && index <= this.visibleEnd) {
        return Promise.resolve();
      }
      this.visibleStart = Math.max(0, index - 10);
      this.visibleEnd = Math.min(this.count(), index + 10);
      return Promise.resolve();
    }

    this.reset();

    return new Promise(() => {
      location.replace(app.route.discussion(this.discussion, number));
    });
  }
}
